require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ./~/angular-resource/index.js
// module id = 442
// module chunks = 36